import React from 'react';
import teamJson from './teamJson.js';
import './team.css'; 
import bgteamtop from '../images/bgteamtop.webp';
import ArrowRight from './ArrowRights.js';

function Team() {
  const teamsWithDomain = teamJson.filter(team => team.dominio);
  const teamsWithoutDomain = teamJson.filter(team => !team.dominio);
  return (
    <>
      <section className='teamBgTop' style={{ backgroundImage: `url(${bgteamtop})` }} name='team'>
        <div className='content'>
        <div className='flexIndex teamInside'>
            <div className='colIndex'>
                <p className='subtitles'>Meet the</p>
                <div className='titles'>
                    <h2>Team <sub>-</sub></h2>
                    <ArrowRight className="custom-arrow" />
                    <span className='bajada'>Somos una agencia digital radicada en Argentina. Nuestra tripulación está conformada por un equipo de profesionales que combinan diseño, tecnología y creatividad para resolver las necesidades de comunicación online de cada empresa.</span>
                </div>
            </div>
            <div className='colIndex'>
                    <ol>
                    {teamsWithDomain.map((team) => {
                    const img = `${process.env.PUBLIC_URL}/images/team/${team.alt}.webp`;
                    return (
                        <li key={team.titulo}>
                        <figure>
                            <img width="100%" src={img} alt={team.titulo} loading="lazy"/>
                        </figure>
                        <div className='datos'>
                            <p className="tituloTeam">{team.titulo}</p>
                            <p className="dominioTeam">{team.dominio}</p>
                            <p className="cargoTeam">{team.cargo}</p>
                            <div className='personal'>
                                <h6><strong>♥ - </strong>{team.gustos}</h6>
                                <h6><strong>Tv Series - </strong>{team.series}</h6>
                                <h6><strong>Movies - </strong>{team.peliculas}</h6>
                                <h6><strong>Music - </strong>{team.musica}</h6>
                            </div>
                        </div>
                        </li>
                    );
                    })}
                </ol>
            </div>
        </div>
        {teamsWithoutDomain.length > 0 && (
                    <>
                    <ol className='fullteam'>
                        {teamsWithoutDomain.map((team) => {
                        const img = `${process.env.PUBLIC_URL}/images/team/${team.alt}.webp`;
                        return (
                            <li key={team.titulo}>
                            <figure>
                                <img width="100%" src={img} alt={team.titulo} loading="lazy"/>
                            </figure>
                            <div className='datos'>
                                <h4>{team.titulo}</h4>
                                <h5>{team.cargo}</h5>
                                <div className='personal'>
                                    <h6><strong>♥ - </strong>{team.gustos}</h6>
                                    <h6><strong>Tv Series - </strong>{team.series}</h6>
                                    <h6><strong>Movies - </strong>{team.peliculas}</h6>
                                    <h6><strong>Music - </strong>{team.musica}</h6>
                                </div>
                            </div>
                            </li>
                        );
                        })}
                    </ol>
                    </>
                )}
        
        
       
          
        </div>
      </section>
    </>
  );
}

export default Team;